import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthorizedRole, isAuthenticated, login } from "./AppSecurity";
import { AccessDenied } from "../components/ErrorFragments";

const shouldDeferLogin = () => typeof navigator !== "undefined" && !navigator.onLine;

/* =====================================================
   AUTHENTICATED ROUTE
   ===================================================== */

export const AuthenticatedRoute = ({ children }) => {
  const location = useLocation();
  let content;

  if (isAuthenticated()) {
    content = children;
  } else if (shouldDeferLogin()) {
    content = <AccessDenied />;
  } else {

    // Store redirect ONLY for protected routes
    sessionStorage.setItem("postLoginRedirect", location.pathname);

    content = login({
      redirectUri: window.location.origin + location.pathname
    });
  }

  return <>{content}</>;
};

/* =====================================================
   ROLE-BASED ROUTE
   ===================================================== */

export const RouteByRole = ({ roles, children }) => {
  const location = useLocation();
  let content;

  if (!isAuthenticated()) {

    // Store redirect ONLY for protected routes
    sessionStorage.setItem("postLoginRedirect", location.pathname);

    content = shouldDeferLogin()
      ? <AccessDenied />
      : login({
          redirectUri: window.location.origin + location.pathname
        });

  } else if (isAuthorizedRole(roles)) {
    content = children;
  } else {
    content = <AccessDenied />;
  }

  return <>{content}</>;
};

/* =====================================================
   PROPTYPES
   ===================================================== */

AuthenticatedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

RouteByRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};
